import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/query';
import { CircularProgressCentered } from '../../app/components/sharedcomponents';
import { Calculate } from '@mui/icons-material';
import { useAuthProfile } from "../../app/hooks"
 import { Box, Link } from '@mui/material';
 import Typography from '@mui/material/Typography'
 import Stack from '@mui/material/Stack';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import { MainSignIn } from '../iam/MainSignIn';
import { useLocation } from 'react-router-dom';

interface UnAuthorizedMessageProps {
    children?: React.ReactNode; // Optional children prop with default value
}

export const UnAuthorizedMessage: React.FC<UnAuthorizedMessageProps> = ({ 
    children = (
          <Stack  direction="row" display="flex" alignItems="flex-start" justifyContent="left" spacing={0}
                    sx={{  border: 1, borderColor: 'primary.main', borderRadius: 2, p: 1 , mt: { xs: 0, sm: 0 },  mb: { xs: 2, sm: 4 }}}
                >
            <TextsmsOutlinedIcon fontSize='large' color="primary" />
            <Typography align='center' variant='subtitle2'>
                Please sign-in for community and private Journal and to message others
            </Typography>
         </Stack>
    ) 
}) => {
    const { pathname, search, hash } = useLocation();

    return (
        // <Box sx={{
        //     display: 'flex',
        //     flexDirection: 'column',
        //     justifyContent: "center",
        //     marginLeft: 'auto',
        //     marginRight: 'auto',
        //     maxHeight: '90vh'
        // }}>
//Please sign in to use Patient Connect Community Journal and Messaging
            <MainSignIn navigateTo={`${pathname}${search}${hash}`}>
                <Stack
                    direction="row" display="flex" alignItems="flex-start" justifyContent="left" spacing={0}
                >
                    <Typography align='center' variant='subtitle2' >
                        Please sign-in for journaling and direct messaging</Typography>
                </Stack>
            </MainSignIn>

        // </Box>
    )
}
